import type { ReactNode } from 'react';
import { Text } from '@mantine/core';

export function TableCellText({
  children,
  muted,
  fw,
  maw,
  className,
}: {
  children: ReactNode;
  muted?: boolean;
  fw?: number;
  maw?: number | string;
  className?: string;
}) {
  return (
    <Text
      size="xs"
      c={muted ? 'dimmed' : undefined}
      fw={fw}
      maw={maw}
      className={className}
      style={maw ? { whiteSpace: 'normal', wordBreak: 'break-word', lineHeight: 1.35 } : undefined}
    >
      {children}
    </Text>
  );
}
